import { useState, useEffect, useCallback } from "react";
import { getClienteById } from "../../../services/ClienteService.js";

const useClienteCotizacion = (baseUrl, idCliente, enabled) => {
  const [cliente, setCliente] = useState(null);
  const [loadingCliente, setLoadingCliente] = useState(false);

  const fetchCliente = useCallback(async () => {
    try {
      setLoadingCliente(true);
      const data = await getClienteById(baseUrl, idCliente);
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    } finally {
      setLoadingCliente(false);
    }
  }, [baseUrl, idCliente]);

  useEffect(() => {
    if (enabled && idCliente) {
      fetchCliente();
    }
  }, [enabled, idCliente, fetchCliente]);

  return { cliente, setCliente, loadingCliente };
};

export default useClienteCotizacion;
